
import React from 'react';
import { Lead } from '@/types/lead';
import ReviewsPanel from '@/components/ReviewsPanel';

interface ReviewsTabContentProps {
  lead: Lead;
}

const ReviewsTabContent: React.FC<ReviewsTabContentProps> = ({ lead }) => {
  return (
    <div className="space-y-4">
      <ReviewsPanel lead={lead} />
    </div>
  );
};

export default ReviewsTabContent;
